import * as graphql from 'generated/graphql';

import { useFeatureDetails } from '../packages/kakapo-ui-application/hooks/useFeature';

import { useHistory } from 'react-router';

import { Spinner } from '@treams/treams-ui';
import { Flex } from '@mantine/core';

import MainLayout from 'packages/kakapo-ui-application/layouts/MainLayout';

import EvaluationSubmission from 'conversations/evaluation-submission/EvaluationSubmission';
import ConversationHOC from './conversation/ConversationHOC';

export default function PrintConversation(props: { conversationID: string }) {
	const history = useHistory();

	const { available, loading } = useFeatureDetails(graphql.FeatureName.Q3_2024Conversations);

	const handlePrint = () => {
		// Wait until all elements are done loading
		setTimeout(() => {
			window.print();

			history.goBack();
		});
	};

	if (loading) {
		return (
			<Flex align="center" justify="center" p="60px">
				<Spinner size="18px" />
			</Flex>
		);
	}

	return (
		<MainLayout print>
			<style>
				{`* {
					color-adjust: exact!important;  
					-webkit-print-color-adjust: exact!important; 
					print-color-adjust: exact!important;
				}`}
			</style>
			{available ? (
				<ConversationHOC conversationID={props.conversationID} onCompleted={handlePrint} />
			) : (
				<EvaluationSubmission
					evaluationSubmissionID={props.conversationID}
					onCompleted={handlePrint}
				/>
			)}
		</MainLayout>
	);
}
